import * as Yup from "yup";
import { transformSnakeToCamel, transformModelToJson } from "utils/transform";
import { PaginationSchema } from "model/_common";
import { ProductSchema } from "model/_base/products/product.schema";
import { StatsSchema } from "model/_base/stats/stats.schema";

// Yup Schemas
export const DataSchema = ProductSchema.clone().transform(transformSnakeToCamel).shape({
  stats: StatsSchema,
});

export const ProductsSchema = Yup.object().shape({
  data: Yup.array().of(DataSchema),
  pagination: PaginationSchema,
});

export default class ProductsModel {
  /**
   * Transform json to model
   * @param {object} json - JSON data to transform
   * @returns {object} Transformed model
   */
  static jsonToModel(json) {
    try {
      const model = ProductsSchema.cast(json, {
        abortEarly: false,
        stripUnknown: true,
      });
      return model;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Transform model to json
   * @param {object} model - Model to transform
   * @returns {object} Transformed json
   */
  static modelToJson(model) {
    return transformModelToJson(model);
  }
}
